export class requestIllustration{
    id : string;
    processId : string;
    clientName : string;
  }
  